export default __webpack_public_path__ + "static/media/whiteSILogo.f21c434e.svg";